@import '~style-sheet-helpers/core.less';
@import (reference) '~ss-ui-client/src/constants/spacing.module.less';

.product-search-container {
  width: 100%;
}

.input-wrapper {
  position: relative;
  flex: 1;
}

.search-input {
  flex: 1;
}

.scanner-icon {
  position: absolute;
  height: 16px;
  aspect-ratio: 1;
  right: @space-8;
  top: @space-8;
  z-index: 2;
}

.add-button {
  min-width: 80px;
}

.helper-text {
  font-size: 12px;
  margin-top: @space-8;
  color: var(--grey-600);
}

.search-results {
  position: relative;

  .result-dropdown-menu {
    position: absolute;
    bottom: auto;
    top: 35px;
    z-index: 2;
    left: 0;
    background-color: var(--white);
    border-radius: 4px;
    border: 1px solid var(--grey-300);
    max-height: 300px;
    overflow: auto;
    width: 100%;
    box-shadow: 3px 2px 2px var(--black-fade-20);
  }

  .row {
    white-space: normal;
  }

  .item-name {
    margin-bottom: @space-4;
    color: var(--grey-1000);
    line-height: 1.2;
  }

  .item-sku {
    color: var(--grey-700);
  }

  .item-name,
  .item-sku {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    width: 100%;
  }

  .result-item {
    border-bottom: 1px solid var(--grey-400);

    &:last-child {
      border-bottom: 0;
    }
  }

  .result-message {
    padding: @space-8;
    background-color: var(--blue-200);
  }
}
